import {UniqueIdentifier} from '@dnd-kit/core';

import {isNil} from 'ramda';

import {parseDndItemId} from '@dms/features/dnd';

export interface SortableDndItem {
  id: string;
  url: string;
  position: number;
  containerId: string;
}

/**
 * The parts of a sortable tile id; `null` for a droppable container id. `parseDndItemId` widens
 * `isSortable` to `boolean` and types the parts as optional, so the sortable branch is told
 * apart by its fields.
 */
export const parseSortableDndItemId = (dndId: UniqueIdentifier): SortableDndItem | null => {
  const parsed = parseDndItemId(dndId);
  if (
    !('url' in parsed) ||
    isNil(parsed.url) ||
    isNil(parsed.position) ||
    isNil(parsed.containerId)
  ) {
    return null;
  }
  return {
    id: parsed.id,
    url: parsed.url,
    position: parsed.position,
    containerId: parsed.containerId,
  };
};
